import * as React from 'react';
import { useSidebarToggleEvent } from '../sidebarState';
import { mobileSidebarToggleEventId } from '../sidebarState/sidebarState.constants';
import { emitMobileSidebarToggleEvent } from '../sidebarState/utils/emitSidebarToggleEvent';
export function useMobileSidebar() {
  const [isSidebarOpen, setSidebarOpen] = React.useState(false);
  const handleSidebarToggle = React.useCallback(() => {
    setSidebarOpen(prevState => !prevState);
  }, []);
  React.useEffect(() => {
    emitMobileSidebarToggleEvent(isSidebarOpen);
  }, [isSidebarOpen]);
  useSidebarToggleEvent(mobileSidebarToggleEventId, forcedValue => {
    setSidebarOpen(prevState => forcedValue !== undefined ? forcedValue : !prevState);
  });
  return [isSidebarOpen, handleSidebarToggle];
}